import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpEditPermissionsPage } from '@/features/pcmp/pages/PcmpEditPermissionsPage';

export const Route = createFileRoute('/_auth/pcmp/edit-permissions/')({
  component: () => (
    <ErrorBoundary moduleName="PCMP Edit Permissions">
      <Suspense fallback={<PageLoader />}>
        <PcmpEditPermissionsPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
